/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Bingo
 * The Bingo API
 * OpenAPI spec version: 1.0
 */
import { apiRequest } from './client';
export interface UserDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  firstName: string;
  lastName: string;
  externalId: string;
}

export type PageDtoItemsItem = { [key: string]: unknown };

export interface PageDto {
  items: PageDtoItemsItem[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export interface User { [key: string]: unknown }

export interface SquarePackDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  /** @nullable */
  ownerId: string | null;
  squareCount: number;
  randomCalled: boolean;
  shared: boolean;
}

export type GameDtoStatus = typeof GameDtoStatus[keyof typeof GameDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GameDtoStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
} as const;

export type GameDtoWinCondition = typeof GameDtoWinCondition[keyof typeof GameDtoWinCondition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GameDtoWinCondition = {
  LINE: 'LINE',
  BLACKOUT: 'BLACKOUT',
  FOUR_CORNERS: 'FOUR_CORNERS',
} as const;

export interface GameDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  status: GameDtoStatus;
  winCondition: GameDtoWinCondition;
  automatic: boolean;
  ownerId: string;
  owner: User;
  squarePackId: string;
  squarePack: SquarePackDto;
  playerCount: number;
  /** @nullable */
  shortId: string | null;
}

export type CreateGameDtoWinCondition = typeof CreateGameDtoWinCondition[keyof typeof CreateGameDtoWinCondition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateGameDtoWinCondition = {
  LINE: 'LINE',
  BLACKOUT: 'BLACKOUT',
  FOUR_CORNERS: 'FOUR_CORNERS',
} as const;

export interface CreateGameDto {
  title: string;
  winCondition: CreateGameDtoWinCondition;
  automatic: boolean;
  squarePackId: string;
}

export type UpdateGameStatusDtoStatus = typeof UpdateGameStatusDtoStatus[keyof typeof UpdateGameStatusDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateGameStatusDtoStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
} as const;

export interface UpdateGameStatusDto {
  status: UpdateGameStatusDtoStatus;
}

export interface JoinGameDto {
  /** Display name for the player */
  firstName: string;
}

export interface GamePlayerDto {
  /** ID of the game player record */
  id: string;
  /** ID of the game */
  gameId: string;
  /** ID of the registered user (null for anonymous players) */
  playerId?: string;
  /** Registered user profile (null for anonymous players) */
  player?: UserDto;
  /** Display name of the player */
  firstName: string;
}

export interface ClaimBingoDto {
  /** The score card ID to validate for bingo */
  scoreCardId: string;
}

export interface GameSquareDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  free: boolean;
  squarePackId: string;
}

export interface ScoreCardGameSquareDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  xCoordinate: number;
  yCoordinate: number;
  marked: boolean;
  scoreCardId: string;
  gameSquareId: string;
  gameSquare: GameSquareDto;
}

/**
 * The current status of the game
 */
export type ScoreCardDtoGameStatus = typeof ScoreCardDtoGameStatus[keyof typeof ScoreCardDtoGameStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScoreCardDtoGameStatus = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
} as const;

export interface ScoreCardDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  /** The ID of the game this score card belongs to */
  gameId: string;
  /** The title of the game */
  gameTitle: string;
  /** Whether the game automatically marks and ends */
  gameAutomatic: boolean;
  /** The GamePlayer ID this score card belongs to */
  gamePlayerId: string;
  /** Whether the player has achieved bingo on this card */
  hasWon: boolean;
  /** The current status of the game */
  gameStatus: ScoreCardDtoGameStatus;
  /** The ID of the square pack used in the game */
  squarePackId: string;
  /** Whether the square pack is publicly shareable */
  squarePackShared: boolean;
  /** The game squares on this score card */
  scoreCardGameSquares: ScoreCardGameSquareDto[];
}

export type BingoClaimResultDtoOutcome = typeof BingoClaimResultDtoOutcome[keyof typeof BingoClaimResultDtoOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BingoClaimResultDtoOutcome = {
  invalid_marks: 'invalid_marks',
  no_bingo: 'no_bingo',
  winner: 'winner',
} as const;

export interface BingoClaimResultDto {
  outcome: BingoClaimResultDtoOutcome;
  scoreCard: ScoreCardDto;
}

export interface CreatePackDto {
  title: string;
  randomCalled?: boolean;
}

export interface UpdatePackDto {
  title?: string;
  shared?: boolean;
}

export interface AddSquareDto {
  title: string;
}

export interface UpdateSquareDto {
  title?: string;
  free?: boolean;
}

export interface GenerateSquareSuggestionsDto {
  topic: string;
}

export interface SquareSuggestionsDto {
  suggestions: string[];
}

export interface HostTierDto {
  tier: string;
  /** @nullable */
  expiresAt: string | null;
  playerLimit: number;
}

export type CreateCheckoutSessionDtoTargetTier = typeof CreateCheckoutSessionDtoTargetTier[keyof typeof CreateCheckoutSessionDtoTargetTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCheckoutSessionDtoTargetTier = {
  party_pass: 'party_pass',
  mega_party: 'mega_party',
} as const;

export interface CreateCheckoutSessionDto {
  targetTier: CreateCheckoutSessionDtoTargetTier;
  gameId: string;
}

export interface UpdateScoreCardMarksDto {
  /** IDs of game squares the player wants marked on their card */
  marks: string[];
}

export interface CallSquareDto {
  /** Square ID for host-pick mode packs; omit for random-called mode packs */
  squareId?: string;
}

export interface CalledGameSquare { [key: string]: unknown }

export type GameActionsControllerGetUserOwnedGamesParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type GameActionsControllerGetGamePlayersParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type SquarePacksControllerListParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type SquarePacksControllerGetSquaresParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type BillingControllerCreateCheckout201 = {
  url: string;
};

export type GamePlayerActionsControllerGetGamesAsPlayerParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type GameCallerActionsControllerGetCalledSquaresParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type appControllerHelloWorldResponse200 = {
  data: void
  status: 200
}
    
export type appControllerHelloWorldResponseSuccess = (appControllerHelloWorldResponse200) & {
  headers: Headers;
};
;

export type appControllerHelloWorldResponse = (appControllerHelloWorldResponseSuccess)

export const getAppControllerHelloWorldUrl = () => {


  

  return `/`
}

export const appControllerHelloWorld = async ( options?: RequestInit): Promise<appControllerHelloWorldResponse> => {
  
  return apiRequest<appControllerHelloWorldResponse>(getAppControllerHelloWorldUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get the current user
 */
export type userControllerGetCurrentUserResponse200 = {
  data: UserDto
  status: 200
}

export type userControllerGetCurrentUserResponse404 = {
  data: void
  status: 404
}
    
export type userControllerGetCurrentUserResponseSuccess = (userControllerGetCurrentUserResponse200) & {
  headers: Headers;
};
export type userControllerGetCurrentUserResponseError = (userControllerGetCurrentUserResponse404) & {
  headers: Headers;
};

export type userControllerGetCurrentUserResponse = (userControllerGetCurrentUserResponseSuccess | userControllerGetCurrentUserResponseError)

export const getUserControllerGetCurrentUserUrl = () => {


  

  return `/users/current`
}

export const userControllerGetCurrentUser = async ( options?: RequestInit): Promise<userControllerGetCurrentUserResponse> => {
  
  return apiRequest<userControllerGetCurrentUserResponse>(getUserControllerGetCurrentUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get all games owned by the current user
 */
export type gameActionsControllerGetUserOwnedGamesResponse200 = {
  data: PageDto
  status: 200
}
    
export type gameActionsControllerGetUserOwnedGamesResponseSuccess = (gameActionsControllerGetUserOwnedGamesResponse200) & {
  headers: Headers;
};
;

export type gameActionsControllerGetUserOwnedGamesResponse = (gameActionsControllerGetUserOwnedGamesResponseSuccess)

export const getGameActionsControllerGetUserOwnedGamesUrl = (params?: GameActionsControllerGetUserOwnedGamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/games?${stringifiedParams}` : `/games`
}

export const gameActionsControllerGetUserOwnedGames = async (params?: GameActionsControllerGetUserOwnedGamesParams, options?: RequestInit): Promise<gameActionsControllerGetUserOwnedGamesResponse> => {
  
  return apiRequest<gameActionsControllerGetUserOwnedGamesResponse>(getGameActionsControllerGetUserOwnedGamesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a game
 */
export type gameActionsControllerCreateGameResponse201 = {
  data: GameDto
  status: 201
}

export type gameActionsControllerCreateGameResponse403 = {
  data: void
  status: 403
}

export type gameActionsControllerCreateGameResponse404 = {
  data: void
  status: 404
}

export type gameActionsControllerCreateGameResponse502 = {
  data: void
  status: 502
}
    
export type gameActionsControllerCreateGameResponseSuccess = (gameActionsControllerCreateGameResponse201) & {
  headers: Headers;
};
export type gameActionsControllerCreateGameResponseError = (gameActionsControllerCreateGameResponse403 | gameActionsControllerCreateGameResponse404 | gameActionsControllerCreateGameResponse502) & {
  headers: Headers;
};

export type gameActionsControllerCreateGameResponse = (gameActionsControllerCreateGameResponseSuccess | gameActionsControllerCreateGameResponseError)

export const getGameActionsControllerCreateGameUrl = () => {


  

  return `/games`
}

export const gameActionsControllerCreateGame = async (createGameDto: CreateGameDto, options?: RequestInit): Promise<gameActionsControllerCreateGameResponse> => {
  
  return apiRequest<gameActionsControllerCreateGameResponse>(getGameActionsControllerCreateGameUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createGameDto,)
  }
);}



/**
 * @summary List players in a game
 */
export type gameActionsControllerGetGamePlayersResponse200 = {
  data: PageDto
  status: 200
}

export type gameActionsControllerGetGamePlayersResponse403 = {
  data: void
  status: 403
}

export type gameActionsControllerGetGamePlayersResponse404 = {
  data: void
  status: 404
}
    
export type gameActionsControllerGetGamePlayersResponseSuccess = (gameActionsControllerGetGamePlayersResponse200) & {
  headers: Headers;
};
export type gameActionsControllerGetGamePlayersResponseError = (gameActionsControllerGetGamePlayersResponse403 | gameActionsControllerGetGamePlayersResponse404) & {
  headers: Headers;
};

export type gameActionsControllerGetGamePlayersResponse = (gameActionsControllerGetGamePlayersResponseSuccess | gameActionsControllerGetGamePlayersResponseError)

export const getGameActionsControllerGetGamePlayersUrl = (id: string,
    params?: GameActionsControllerGetGamePlayersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/games/${id}/players?${stringifiedParams}` : `/games/${id}/players`
}

export const gameActionsControllerGetGamePlayers = async (id: string,
    params?: GameActionsControllerGetGamePlayersParams, options?: RequestInit): Promise<gameActionsControllerGetGamePlayersResponse> => {
  
  return apiRequest<gameActionsControllerGetGamePlayersResponse>(getGameActionsControllerGetGamePlayersUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Read a game
 */
export type gameActionsControllerGetGameResponse404 = {
  data: void
  status: 404
}

export type gameActionsControllerGetGameResponseDefault = {
  data: GameDto
  status: Exclude<HTTPStatusCodes, 404>
}
    
;
export type gameActionsControllerGetGameResponseError = (gameActionsControllerGetGameResponse404 | gameActionsControllerGetGameResponseDefault) & {
  headers: Headers;
};

export type gameActionsControllerGetGameResponse = (gameActionsControllerGetGameResponseError)

export const getGameActionsControllerGetGameUrl = (id: string,) => {


  

  return `/games/${id}`
}

export const gameActionsControllerGetGame = async (id: string, options?: RequestInit): Promise<gameActionsControllerGetGameResponse> => {
  
  return apiRequest<gameActionsControllerGetGameResponse>(getGameActionsControllerGetGameUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update game status (drive lifecycle transitions)
 */
export type gameActionsControllerUpdateGameStatusResponse200 = {
  data: GameDto
  status: 200
}

export type gameActionsControllerUpdateGameStatusResponse404 = {
  data: void
  status: 404
}
    
export type gameActionsControllerUpdateGameStatusResponseSuccess = (gameActionsControllerUpdateGameStatusResponse200) & {
  headers: Headers;
};
export type gameActionsControllerUpdateGameStatusResponseError = (gameActionsControllerUpdateGameStatusResponse404) & {
  headers: Headers;
};

export type gameActionsControllerUpdateGameStatusResponse = (gameActionsControllerUpdateGameStatusResponseSuccess | gameActionsControllerUpdateGameStatusResponseError)

export const getGameActionsControllerUpdateGameStatusUrl = (id: string,) => {


  

  return `/games/${id}`
}

export const gameActionsControllerUpdateGameStatus = async (id: string,
    updateGameStatusDto: UpdateGameStatusDto, options?: RequestInit): Promise<gameActionsControllerUpdateGameStatusResponse> => {
  
  return apiRequest<gameActionsControllerUpdateGameStatusResponse>(getGameActionsControllerUpdateGameStatusUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateGameStatusDto,)
  }
);}



/**
 * @summary Join a game as a player
 */
export type gameActionsControllerJoinGameResponse201 = {
  data: GamePlayerDto
  status: 201
}

export type gameActionsControllerJoinGameResponse400 = {
  data: void
  status: 400
}

export type gameActionsControllerJoinGameResponse402 = {
  data: void
  status: 402
}

export type gameActionsControllerJoinGameResponse404 = {
  data: void
  status: 404
}
    
export type gameActionsControllerJoinGameResponseSuccess = (gameActionsControllerJoinGameResponse201) & {
  headers: Headers;
};
export type gameActionsControllerJoinGameResponseError = (gameActionsControllerJoinGameResponse400 | gameActionsControllerJoinGameResponse402 | gameActionsControllerJoinGameResponse404) & {
  headers: Headers;
};

export type gameActionsControllerJoinGameResponse = (gameActionsControllerJoinGameResponseSuccess | gameActionsControllerJoinGameResponseError)

export const getGameActionsControllerJoinGameUrl = (id: string,) => {


  

  return `/games/${id}/join`
}

export const gameActionsControllerJoinGame = async (id: string,
    joinGameDto: JoinGameDto, options?: RequestInit): Promise<gameActionsControllerJoinGameResponse> => {
  
  return apiRequest<gameActionsControllerJoinGameResponse>(getGameActionsControllerJoinGameUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      joinGameDto,)
  }
);}



/**
 * @summary Submit a bingo claim for validation
 */
export type gameActionsControllerClaimBingoResponse200 = {
  data: BingoClaimResultDto
  status: 200
}

export type gameActionsControllerClaimBingoResponse404 = {
  data: void
  status: 404
}
    
export type gameActionsControllerClaimBingoResponseSuccess = (gameActionsControllerClaimBingoResponse200) & {
  headers: Headers;
};
export type gameActionsControllerClaimBingoResponseError = (gameActionsControllerClaimBingoResponse404) & {
  headers: Headers;
};

export type gameActionsControllerClaimBingoResponse = (gameActionsControllerClaimBingoResponseSuccess | gameActionsControllerClaimBingoResponseError)

export const getGameActionsControllerClaimBingoUrl = (id: string,) => {


  

  return `/games/${id}/winners`
}

export const gameActionsControllerClaimBingo = async (id: string,
    claimBingoDto: ClaimBingoDto, options?: RequestInit): Promise<gameActionsControllerClaimBingoResponse> => {
  
  return apiRequest<gameActionsControllerClaimBingoResponse>(getGameActionsControllerClaimBingoUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      claimBingoDto,)
  }
);}



/**
 * @summary Remove a player from a game (host only)
 */
export type gameActionsControllerRemovePlayerResponse204 = {
  data: void
  status: 204
}

export type gameActionsControllerRemovePlayerResponse403 = {
  data: void
  status: 403
}

export type gameActionsControllerRemovePlayerResponse404 = {
  data: void
  status: 404
}
    
export type gameActionsControllerRemovePlayerResponseSuccess = (gameActionsControllerRemovePlayerResponse204) & {
  headers: Headers;
};
export type gameActionsControllerRemovePlayerResponseError = (gameActionsControllerRemovePlayerResponse403 | gameActionsControllerRemovePlayerResponse404) & {
  headers: Headers;
};

export type gameActionsControllerRemovePlayerResponse = (gameActionsControllerRemovePlayerResponseSuccess | gameActionsControllerRemovePlayerResponseError)

export const getGameActionsControllerRemovePlayerUrl = (id: string,
    gamePlayerId: string,) => {


  

  return `/games/${id}/players/${gamePlayerId}`
}

export const gameActionsControllerRemovePlayer = async (id: string,
    gamePlayerId: string, options?: RequestInit): Promise<gameActionsControllerRemovePlayerResponse> => {
  
  return apiRequest<gameActionsControllerRemovePlayerResponse>(getGameActionsControllerRemovePlayerUrl(id,gamePlayerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Get the Classic Square Pack
 */
export type squarePackControllerGetClassicPackResponse200 = {
  data: SquarePackDto
  status: 200
}

export type squarePackControllerGetClassicPackResponse404 = {
  data: void
  status: 404
}
    
export type squarePackControllerGetClassicPackResponseSuccess = (squarePackControllerGetClassicPackResponse200) & {
  headers: Headers;
};
export type squarePackControllerGetClassicPackResponseError = (squarePackControllerGetClassicPackResponse404) & {
  headers: Headers;
};

export type squarePackControllerGetClassicPackResponse = (squarePackControllerGetClassicPackResponseSuccess | squarePackControllerGetClassicPackResponseError)

export const getSquarePackControllerGetClassicPackUrl = () => {


  

  return `/square-packs/classic`
}

export const squarePackControllerGetClassicPack = async ( options?: RequestInit): Promise<squarePackControllerGetClassicPackResponse> => {
  
  return apiRequest<squarePackControllerGetClassicPackResponse>(getSquarePackControllerGetClassicPackUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary List all square packs (system + owned by current user)
 */
export type squarePacksControllerListResponse200 = {
  data: PageDto
  status: 200
}
    
export type squarePacksControllerListResponseSuccess = (squarePacksControllerListResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerListResponse = (squarePacksControllerListResponseSuccess)

export const getSquarePacksControllerListUrl = (params?: SquarePacksControllerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/square-packs?${stringifiedParams}` : `/square-packs`
}

export const squarePacksControllerList = async (params?: SquarePacksControllerListParams, options?: RequestInit): Promise<squarePacksControllerListResponse> => {
  
  return apiRequest<squarePacksControllerListResponse>(getSquarePacksControllerListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a new square pack
 */
export type squarePacksControllerCreateResponse201 = {
  data: SquarePackDto
  status: 201
}
    
export type squarePacksControllerCreateResponseSuccess = (squarePacksControllerCreateResponse201) & {
  headers: Headers;
};
;

export type squarePacksControllerCreateResponse = (squarePacksControllerCreateResponseSuccess)

export const getSquarePacksControllerCreateUrl = () => {


  

  return `/square-packs`
}

export const squarePacksControllerCreate = async (createPackDto: CreatePackDto, options?: RequestInit): Promise<squarePacksControllerCreateResponse> => {
  
  return apiRequest<squarePacksControllerCreateResponse>(getSquarePacksControllerCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPackDto,)
  }
);}



/**
 * @summary Get a square pack by ID
 */
export type squarePacksControllerGetOneResponse200 = {
  data: SquarePackDto
  status: 200
}
    
export type squarePacksControllerGetOneResponseSuccess = (squarePacksControllerGetOneResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerGetOneResponse = (squarePacksControllerGetOneResponseSuccess)

export const getSquarePacksControllerGetOneUrl = (id: string,) => {


  

  return `/square-packs/${id}`
}

export const squarePacksControllerGetOne = async (id: string, options?: RequestInit): Promise<squarePacksControllerGetOneResponse> => {
  
  return apiRequest<squarePacksControllerGetOneResponse>(getSquarePacksControllerGetOneUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update square pack (owner only)
 */
export type squarePacksControllerUpdateResponse200 = {
  data: SquarePackDto
  status: 200
}
    
export type squarePacksControllerUpdateResponseSuccess = (squarePacksControllerUpdateResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerUpdateResponse = (squarePacksControllerUpdateResponseSuccess)

export const getSquarePacksControllerUpdateUrl = (id: string,) => {


  

  return `/square-packs/${id}`
}

export const squarePacksControllerUpdate = async (id: string,
    updatePackDto: UpdatePackDto, options?: RequestInit): Promise<squarePacksControllerUpdateResponse> => {
  
  return apiRequest<squarePacksControllerUpdateResponse>(getSquarePacksControllerUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePackDto,)
  }
);}



/**
 * @summary Delete a square pack (owner only)
 */
export type squarePacksControllerDeleteResponse200 = {
  data: void
  status: 200
}
    
export type squarePacksControllerDeleteResponseSuccess = (squarePacksControllerDeleteResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerDeleteResponse = (squarePacksControllerDeleteResponseSuccess)

export const getSquarePacksControllerDeleteUrl = (id: string,) => {


  

  return `/square-packs/${id}`
}

export const squarePacksControllerDelete = async (id: string, options?: RequestInit): Promise<squarePacksControllerDeleteResponse> => {
  
  return apiRequest<squarePacksControllerDeleteResponse>(getSquarePacksControllerDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary List squares in a pack in creation order
 */
export type squarePacksControllerGetSquaresResponse200 = {
  data: PageDto
  status: 200
}
    
export type squarePacksControllerGetSquaresResponseSuccess = (squarePacksControllerGetSquaresResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerGetSquaresResponse = (squarePacksControllerGetSquaresResponseSuccess)

export const getSquarePacksControllerGetSquaresUrl = (id: string,
    params?: SquarePacksControllerGetSquaresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/square-packs/${id}/squares?${stringifiedParams}` : `/square-packs/${id}/squares`
}

export const squarePacksControllerGetSquares = async (id: string,
    params?: SquarePacksControllerGetSquaresParams, options?: RequestInit): Promise<squarePacksControllerGetSquaresResponse> => {
  
  return apiRequest<squarePacksControllerGetSquaresResponse>(getSquarePacksControllerGetSquaresUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Add a square to a pack
 */
export type squarePacksControllerAddSquareResponse201 = {
  data: GameSquareDto
  status: 201
}
    
export type squarePacksControllerAddSquareResponseSuccess = (squarePacksControllerAddSquareResponse201) & {
  headers: Headers;
};
;

export type squarePacksControllerAddSquareResponse = (squarePacksControllerAddSquareResponseSuccess)

export const getSquarePacksControllerAddSquareUrl = (id: string,) => {


  

  return `/square-packs/${id}/squares`
}

export const squarePacksControllerAddSquare = async (id: string,
    addSquareDto: AddSquareDto, options?: RequestInit): Promise<squarePacksControllerAddSquareResponse> => {
  
  return apiRequest<squarePacksControllerAddSquareResponse>(getSquarePacksControllerAddSquareUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addSquareDto,)
  }
);}



/**
 * @summary Update a square title or free designation
 */
export type squarePacksControllerUpdateSquareResponse200 = {
  data: GameSquareDto
  status: 200
}
    
export type squarePacksControllerUpdateSquareResponseSuccess = (squarePacksControllerUpdateSquareResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerUpdateSquareResponse = (squarePacksControllerUpdateSquareResponseSuccess)

export const getSquarePacksControllerUpdateSquareUrl = (id: string,
    squareId: string,) => {


  

  return `/square-packs/${id}/squares/${squareId}`
}

export const squarePacksControllerUpdateSquare = async (id: string,
    squareId: string,
    updateSquareDto: UpdateSquareDto, options?: RequestInit): Promise<squarePacksControllerUpdateSquareResponse> => {
  
  return apiRequest<squarePacksControllerUpdateSquareResponse>(getSquarePacksControllerUpdateSquareUrl(id,squareId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSquareDto,)
  }
);}



/**
 * @summary Remove a square from a pack
 */
export type squarePacksControllerDeleteSquareResponse200 = {
  data: void
  status: 200
}
    
export type squarePacksControllerDeleteSquareResponseSuccess = (squarePacksControllerDeleteSquareResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerDeleteSquareResponse = (squarePacksControllerDeleteSquareResponseSuccess)

export const getSquarePacksControllerDeleteSquareUrl = (id: string,
    squareId: string,) => {


  

  return `/square-packs/${id}/squares/${squareId}`
}

export const squarePacksControllerDeleteSquare = async (id: string,
    squareId: string, options?: RequestInit): Promise<squarePacksControllerDeleteSquareResponse> => {
  
  return apiRequest<squarePacksControllerDeleteSquareResponse>(getSquarePacksControllerDeleteSquareUrl(id,squareId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}



/**
 * @summary Generate AI square suggestions for a pack topic
 */
export type squarePacksControllerGenerateSquareSuggestionsResponse200 = {
  data: SquareSuggestionsDto
  status: 200
}
    
export type squarePacksControllerGenerateSquareSuggestionsResponseSuccess = (squarePacksControllerGenerateSquareSuggestionsResponse200) & {
  headers: Headers;
};
;

export type squarePacksControllerGenerateSquareSuggestionsResponse = (squarePacksControllerGenerateSquareSuggestionsResponseSuccess)

export const getSquarePacksControllerGenerateSquareSuggestionsUrl = (id: string,) => {


  

  return `/square-packs/${id}/square-suggestions`
}

export const squarePacksControllerGenerateSquareSuggestions = async (id: string,
    generateSquareSuggestionsDto: GenerateSquareSuggestionsDto, options?: RequestInit): Promise<squarePacksControllerGenerateSquareSuggestionsResponse> => {
  
  return apiRequest<squarePacksControllerGenerateSquareSuggestionsResponse>(getSquarePacksControllerGenerateSquareSuggestionsUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      generateSquareSuggestionsDto,)
  }
);}



/**
 * @summary Get the current host tier status
 */
export type billingControllerGetTierResponse200 = {
  data: HostTierDto
  status: 200
}
    
export type billingControllerGetTierResponseSuccess = (billingControllerGetTierResponse200) & {
  headers: Headers;
};
;

export type billingControllerGetTierResponse = (billingControllerGetTierResponseSuccess)

export const getBillingControllerGetTierUrl = () => {


  

  return `/billing/tier`
}

export const billingControllerGetTier = async ( options?: RequestInit): Promise<billingControllerGetTierResponse> => {
  
  return apiRequest<billingControllerGetTierResponse>(getBillingControllerGetTierUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Create a Stripe Checkout session for a tier upgrade
 */
export type billingControllerCreateCheckoutResponse201 = {
  data: BillingControllerCreateCheckout201
  status: 201
}
    
export type billingControllerCreateCheckoutResponseSuccess = (billingControllerCreateCheckoutResponse201) & {
  headers: Headers;
};
;

export type billingControllerCreateCheckoutResponse = (billingControllerCreateCheckoutResponseSuccess)

export const getBillingControllerCreateCheckoutUrl = () => {


  

  return `/billing/checkout`
}

export const billingControllerCreateCheckout = async (createCheckoutSessionDto: CreateCheckoutSessionDto, options?: RequestInit): Promise<billingControllerCreateCheckoutResponse> => {
  
  return apiRequest<billingControllerCreateCheckoutResponse>(getBillingControllerCreateCheckoutUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCheckoutSessionDto,)
  }
);}



export type billingControllerHandleWebhookResponse200 = {
  data: void
  status: 200
}
    
export type billingControllerHandleWebhookResponseSuccess = (billingControllerHandleWebhookResponse200) & {
  headers: Headers;
};
;

export type billingControllerHandleWebhookResponse = (billingControllerHandleWebhookResponseSuccess)

export const getBillingControllerHandleWebhookUrl = () => {


  

  return `/billing/webhook`
}

export const billingControllerHandleWebhook = async ( options?: RequestInit): Promise<billingControllerHandleWebhookResponse> => {
  
  return apiRequest<billingControllerHandleWebhookResponse>(getBillingControllerHandleWebhookUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Get all games where the current user is a player
 */
export type gamePlayerActionsControllerGetGamesAsPlayerResponse200 = {
  data: PageDto
  status: 200
}
    
export type gamePlayerActionsControllerGetGamesAsPlayerResponseSuccess = (gamePlayerActionsControllerGetGamesAsPlayerResponse200) & {
  headers: Headers;
};
;

export type gamePlayerActionsControllerGetGamesAsPlayerResponse = (gamePlayerActionsControllerGetGamesAsPlayerResponseSuccess)

export const getGamePlayerActionsControllerGetGamesAsPlayerUrl = (params?: GamePlayerActionsControllerGetGamesAsPlayerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/players/games?${stringifiedParams}` : `/players/games`
}

export const gamePlayerActionsControllerGetGamesAsPlayer = async (params?: GamePlayerActionsControllerGetGamesAsPlayerParams, options?: RequestInit): Promise<gamePlayerActionsControllerGetGamesAsPlayerResponse> => {
  
  return apiRequest<gamePlayerActionsControllerGetGamesAsPlayerResponse>(getGamePlayerActionsControllerGetGamesAsPlayerUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get the current user's GamePlayer for a game
 */
export type gamePlayerActionsControllerGetMyGamePlayerResponse200 = {
  data: GamePlayerDto
  status: 200
}

export type gamePlayerActionsControllerGetMyGamePlayerResponse404 = {
  data: void
  status: 404
}
    
export type gamePlayerActionsControllerGetMyGamePlayerResponseSuccess = (gamePlayerActionsControllerGetMyGamePlayerResponse200) & {
  headers: Headers;
};
export type gamePlayerActionsControllerGetMyGamePlayerResponseError = (gamePlayerActionsControllerGetMyGamePlayerResponse404) & {
  headers: Headers;
};

export type gamePlayerActionsControllerGetMyGamePlayerResponse = (gamePlayerActionsControllerGetMyGamePlayerResponseSuccess | gamePlayerActionsControllerGetMyGamePlayerResponseError)

export const getGamePlayerActionsControllerGetMyGamePlayerUrl = (gameId: string,) => {


  

  return `/players/games/${gameId}/my-player`
}

export const gamePlayerActionsControllerGetMyGamePlayer = async (gameId: string, options?: RequestInit): Promise<gamePlayerActionsControllerGetMyGamePlayerResponse> => {
  
  return apiRequest<gamePlayerActionsControllerGetMyGamePlayerResponse>(getGamePlayerActionsControllerGetMyGamePlayerUrl(gameId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get score card by game player ID (no auth required)
 */
export type gamePlayerActionsControllerGetScoreCardForGamePlayerResponse200 = {
  data: ScoreCardDto
  status: 200
}

export type gamePlayerActionsControllerGetScoreCardForGamePlayerResponse404 = {
  data: void
  status: 404
}
    
export type gamePlayerActionsControllerGetScoreCardForGamePlayerResponseSuccess = (gamePlayerActionsControllerGetScoreCardForGamePlayerResponse200) & {
  headers: Headers;
};
export type gamePlayerActionsControllerGetScoreCardForGamePlayerResponseError = (gamePlayerActionsControllerGetScoreCardForGamePlayerResponse404) & {
  headers: Headers;
};

export type gamePlayerActionsControllerGetScoreCardForGamePlayerResponse = (gamePlayerActionsControllerGetScoreCardForGamePlayerResponseSuccess | gamePlayerActionsControllerGetScoreCardForGamePlayerResponseError)

export const getGamePlayerActionsControllerGetScoreCardForGamePlayerUrl = (gameId: string,
    gamePlayerId: string,) => {


  

  return `/players/games/${gameId}/score-card/${gamePlayerId}`
}

export const gamePlayerActionsControllerGetScoreCardForGamePlayer = async (gameId: string,
    gamePlayerId: string, options?: RequestInit): Promise<gamePlayerActionsControllerGetScoreCardForGamePlayerResponse> => {
  
  return apiRequest<gamePlayerActionsControllerGetScoreCardForGamePlayerResponse>(getGamePlayerActionsControllerGetScoreCardForGamePlayerUrl(gameId,gamePlayerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Update marks on a score card (manual mode only)
 */
export type gamePlayerActionsControllerUpdateScoreCardMarksResponse200 = {
  data: ScoreCardDto
  status: 200
}

export type gamePlayerActionsControllerUpdateScoreCardMarksResponse400 = {
  data: void
  status: 400
}

export type gamePlayerActionsControllerUpdateScoreCardMarksResponse404 = {
  data: void
  status: 404
}
    
export type gamePlayerActionsControllerUpdateScoreCardMarksResponseSuccess = (gamePlayerActionsControllerUpdateScoreCardMarksResponse200) & {
  headers: Headers;
};
export type gamePlayerActionsControllerUpdateScoreCardMarksResponseError = (gamePlayerActionsControllerUpdateScoreCardMarksResponse400 | gamePlayerActionsControllerUpdateScoreCardMarksResponse404) & {
  headers: Headers;
};

export type gamePlayerActionsControllerUpdateScoreCardMarksResponse = (gamePlayerActionsControllerUpdateScoreCardMarksResponseSuccess | gamePlayerActionsControllerUpdateScoreCardMarksResponseError)

export const getGamePlayerActionsControllerUpdateScoreCardMarksUrl = (gameId: string,
    scoreCardId: string,) => {


  

  return `/players/games/${gameId}/score-cards/${scoreCardId}`
}

export const gamePlayerActionsControllerUpdateScoreCardMarks = async (gameId: string,
    scoreCardId: string,
    updateScoreCardMarksDto: UpdateScoreCardMarksDto, options?: RequestInit): Promise<gamePlayerActionsControllerUpdateScoreCardMarksResponse> => {
  
  return apiRequest<gamePlayerActionsControllerUpdateScoreCardMarksResponse>(getGamePlayerActionsControllerUpdateScoreCardMarksUrl(gameId,scoreCardId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateScoreCardMarksDto,)
  }
);}



/**
 * @summary Mark a game square as played on a score card
 */
export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponse200 = {
  data: ScoreCardGameSquareDto
  status: 200
}

export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponse400 = {
  data: void
  status: 400
}

export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponse403 = {
  data: void
  status: 403
}

export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponse404 = {
  data: void
  status: 404
}
    
export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponseSuccess = (gamePlayerActionsControllerMarkGameSquareAsPlayedResponse200) & {
  headers: Headers;
};
export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponseError = (gamePlayerActionsControllerMarkGameSquareAsPlayedResponse400 | gamePlayerActionsControllerMarkGameSquareAsPlayedResponse403 | gamePlayerActionsControllerMarkGameSquareAsPlayedResponse404) & {
  headers: Headers;
};

export type gamePlayerActionsControllerMarkGameSquareAsPlayedResponse = (gamePlayerActionsControllerMarkGameSquareAsPlayedResponseSuccess | gamePlayerActionsControllerMarkGameSquareAsPlayedResponseError)

export const getGamePlayerActionsControllerMarkGameSquareAsPlayedUrl = (gameId: string,
    scoreCardId: string,
    gameSquareId: string,) => {


  

  return `/players/games/${gameId}/score-cards/${scoreCardId}/game-squares/${gameSquareId}/mark`
}

export const gamePlayerActionsControllerMarkGameSquareAsPlayed = async (gameId: string,
    scoreCardId: string,
    gameSquareId: string, options?: RequestInit): Promise<gamePlayerActionsControllerMarkGameSquareAsPlayedResponse> => {
  
  return apiRequest<gamePlayerActionsControllerMarkGameSquareAsPlayedResponse>(getGamePlayerActionsControllerMarkGameSquareAsPlayedUrl(gameId,scoreCardId,gameSquareId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}



/**
 * @summary Call a square for the game (random or host-pick depending on pack mode)
 */
export type gameCallerActionsControllerCallSquareResponse201 = {
  data: CalledGameSquare
  status: 201
}
    
export type gameCallerActionsControllerCallSquareResponseSuccess = (gameCallerActionsControllerCallSquareResponse201) & {
  headers: Headers;
};
;

export type gameCallerActionsControllerCallSquareResponse = (gameCallerActionsControllerCallSquareResponseSuccess)

export const getGameCallerActionsControllerCallSquareUrl = (id: string,) => {


  

  return `/games/${id}/called-squares`
}

export const gameCallerActionsControllerCallSquare = async (id: string,
    callSquareDto: CallSquareDto, options?: RequestInit): Promise<gameCallerActionsControllerCallSquareResponse> => {
  
  return apiRequest<gameCallerActionsControllerCallSquareResponse>(getGameCallerActionsControllerCallSquareUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      callSquareDto,)
  }
);}



/**
 * @summary List all called squares for a game
 */
export type gameCallerActionsControllerGetCalledSquaresResponse200 = {
  data: PageDto
  status: 200
}
    
export type gameCallerActionsControllerGetCalledSquaresResponseSuccess = (gameCallerActionsControllerGetCalledSquaresResponse200) & {
  headers: Headers;
};
;

export type gameCallerActionsControllerGetCalledSquaresResponse = (gameCallerActionsControllerGetCalledSquaresResponseSuccess)

export const getGameCallerActionsControllerGetCalledSquaresUrl = (id: string,
    params?: GameCallerActionsControllerGetCalledSquaresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/games/${id}/called-squares?${stringifiedParams}` : `/games/${id}/called-squares`
}

export const gameCallerActionsControllerGetCalledSquares = async (id: string,
    params?: GameCallerActionsControllerGetCalledSquaresParams, options?: RequestInit): Promise<gameCallerActionsControllerGetCalledSquaresResponse> => {
  
  return apiRequest<gameCallerActionsControllerGetCalledSquaresResponse>(getGameCallerActionsControllerGetCalledSquaresUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Health check — verifies DB and Stripe connectivity
 */
export type healthControllerCheckResponse200 = {
  data: void
  status: 200
}
    
export type healthControllerCheckResponseSuccess = (healthControllerCheckResponse200) & {
  headers: Headers;
};
;

export type healthControllerCheckResponse = (healthControllerCheckResponseSuccess)

export const getHealthControllerCheckUrl = () => {


  

  return `/health`
}

export const healthControllerCheck = async ( options?: RequestInit): Promise<healthControllerCheckResponse> => {
  
  return apiRequest<healthControllerCheckResponse>(getHealthControllerCheckUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
